import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-retry",
  "use": "icon-retry-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-retry\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M22 22H2V2h20z\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M17.626 16.033C16.299 17.846 14.11 19.007 11.67 19c-3.651-.01-6.726-2.636-7.18-6.131-.452-3.495 1.858-6.77 5.395-7.647 3.536-.877 7.198.917 8.55 4.189m1.242-3.412v4h-4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol